// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QYbz","colMin":"styles_colMin__1FPw0"};